module.exports = __webpack_public_path__ + "img/icon-rqfc.21e86558.png";